// @flow
import { combineReducers } from 'redux';
import { authReducer } from '@an/nova-frontend-auth';

const rootReducer = combineReducers({
  auth: authReducer,
});

export default rootReducer;
